// OtpInputGroup.jsx
import { useRef, useEffect } from 'react';

export default function OtpInputGroup({ length = 6, otpCode, setOtpCode, rowIndex }) {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ''); // allow only digits
    if (!value) return;

    const newOtp = [...otpCode];
    newOtp[index] = value;
    setOtpCode(newOtp);

    if (index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      const newOtp = [...otpCode];
      if (otpCode[index]) {
        newOtp[index] = '';
      } else if (index > 0) {
        newOtp[index - 1] = '';
        inputRefs.current[index - 1]?.focus();
      }
      setOtpCode(newOtp);
    } else if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === 'ArrowRight' && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  useEffect(() => {
    // Auto-focus first input on load
    inputRefs.current[0]?.focus();
  }, []);

  return (
    <div className="pin-inputs">
      {Array(length).fill('').map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={otpCode[index] || ''}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          className="pin-input"
          ref={(el) => (inputRefs.current[index] = el)}
          data-row={rowIndex}
        />
      ))}
    </div>
  );
}
